import { FC, useContext, useMemo } from 'react';

import cn from 'classnames';

import { LocalizationContext } from 'localization';

import s from './DiscInfo.module.scss';

export interface IProgressBarProps {
  total: number;
  used: number;
  letter: string;
}

const formatSpace = (space: number): string => (space / 1024).toFixed(1);

export const DiscInfo: FC<IProgressBarProps> = ({ total, used, letter }) => {
  const { t } = useContext(LocalizationContext);

  const progress: number = useMemo(
    () => (used > total ? 100 : Math.round((used * 100) / total)),
    [used, total]
  );
  const available = total - used;

  return (
    <div className={s.container}>
      <div className={s.top}>
        <span className={s.letter}>{letter}</span>
        <div className={s.progressBG}>
          <div
            className={cn(
              s.progress,
              progress >= 85 && s.orange,
              progress >= 95 && s.red
            )}
            style={{ width: progress + '%' }}
          />
        </div>
      </div>
      <div className={s.placeholder}>
        {t('host.storage.space', formatSpace(available), formatSpace(total))}
      </div>
    </div>
  );
};
